/* WCAG 2.2 AA, part 2 of 2. Loads AFTER wcc.js.
 * Augments the theme's behaviour from outside rather than editing wcc.js.
 */
(function () {
  'use strict';

  var live = document.createElement('div');
  live.className = 'wcc-sr-only';
  live.setAttribute('role', 'status');
  live.setAttribute('aria-live', 'polite');
  document.body.appendChild(live);
  function say(msg) { live.textContent = ''; setTimeout(function () { live.textContent = msg; }, 60); }

  var FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';

  /* ---- 2.4.3 Focus Order, 2.1.2 No Keyboard Trap ---------------------
   * wcc.js opens the cart drawer and mobile nav by toggling a class and
   * aria-hidden. Nothing moved focus in, nothing trapped it, nothing restored
   * it, and grep found no Escape handler anywhere in the file. Below 1024px
   * the mobile nav is the ONLY navigation, so a keyboard user could open it
   * and never reach the site.
   */
  var returnTo = null;

  function panelOpen(p) { return p && p.classList.contains('open'); }

  function trap(panel, e) {
    if (e.key !== 'Tab') return;
    var items = panel.querySelectorAll(FOCUSABLE);
    if (!items.length) return;
    var first = items[0], last = items[items.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  function closePanel(panel) {
    var back = document.getElementById('Backdrop');
    if (back) back.click();
    if (returnTo && document.contains(returnTo)) returnTo.focus();
    returnTo = null;
  }

  function watchPanel(id, name) {
    var panel = document.getElementById(id);
    if (!panel) return;
    panel.setAttribute('role', 'dialog');
    panel.setAttribute('aria-modal', 'true');
    if (!panel.getAttribute('aria-label')) panel.setAttribute('aria-label', name);

    new MutationObserver(function () {
      if (panelOpen(panel)) {
        returnTo = returnTo || document.activeElement;
        var target = panel.querySelector('h2,h3,[tabindex="-1"]') || panel.querySelector(FOCUSABLE);
        if (target) {
          if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
          setTimeout(function () { target.focus(); }, 30);
        }
        say(name + ' opened');
      }
    }).observe(panel, { attributes: true, attributeFilter: ['class'] });

    panel.addEventListener('keydown', function (e) { trap(panel, e); });
  }

  watchPanel('CartDrawer', 'Cart');
  watchPanel('MobNav', 'Menu');

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var cart = document.getElementById('CartDrawer');
    var nav = document.getElementById('MobNav');
    if (panelOpen(cart)) { closePanel(cart); return; }
    if (panelOpen(nav)) { closePanel(nav); }
  });

  /* ---- 4.1.2 / 4.1.3 add to cart -------------------------------------
   * wcc.js sets btn.disabled and replaces the label with an empty spinner
   * span, so the control loses its accessible name and drops out of the tab
   * order mid-request, dumping focus to body with nothing announced.
   */
  new MutationObserver(function (muts) {
    muts.forEach(function (m) {
      var btn = m.target.closest ? m.target.closest('[data-atc-btn]') : null;
      if (!btn) return;
      if (btn.querySelector('.wcc-spin')) {
        if (!btn.dataset.wccBusy) {
          btn.dataset.wccBusy = '1';
          btn.setAttribute('aria-label', 'Adding to cart, please wait');
          btn.setAttribute('aria-busy', 'true');
          say('Adding to cart');
        }
      } else if (btn.dataset.wccBusy) {
        delete btn.dataset.wccBusy;
        btn.removeAttribute('aria-busy');
        btn.removeAttribute('aria-label');
        say('Added to cart');
        setTimeout(function () { if (document.contains(btn)) btn.focus(); }, 40);
      }
    });
  }).observe(document.body, { childList: true, subtree: true });

  /* ---- 4.1.2 variant buttons ----------------------------------------- */
  document.querySelectorAll('[data-vgroup]').forEach(function (g) {
    g.setAttribute('role', 'radiogroup');
    var sync = function () {
      g.querySelectorAll('.vbtn').forEach(function (b) {
        b.setAttribute('role', 'radio');
        b.setAttribute('aria-checked', b.classList.contains('on') ? 'true' : 'false');
      });
    };
    sync();
    g.addEventListener('click', function () { setTimeout(sync, 0); });
  });

  /* ---- 4.1.3 collection filters --------------------------------------
   * wcc.js dims #CollGrid to opacity .4 and swaps innerHTML with no
   * announcement and no result count.
   */
  var grid = document.getElementById('CollGrid');
  if (grid) {
    var last = grid.querySelectorAll('[class*="pc"],li,article').length;
    new MutationObserver(function () {
      var dim = parseFloat(grid.style.opacity || '1') < 0.9;
      grid.setAttribute('aria-busy', dim ? 'true' : 'false');
      if (!dim) {
        var n = grid.querySelectorAll('[class*="pc"],li,article').length;
        if (n !== last) { last = n; say(n + ' products match'); }
      }
    }).observe(grid, { attributes: true, attributeFilter: ['style'], childList: true });
  }
  var ft = document.getElementById('FilterToggle');
  var fs = document.getElementById('FilterSidebar');
  if (ft && fs) {
    ft.setAttribute('aria-controls', 'FilterSidebar');
    var syncFt = function () { ft.setAttribute('aria-expanded', fs.classList.contains('open') ? 'true' : 'false'); };
    syncFt();
    ft.addEventListener('click', function () { setTimeout(syncFt, 0); });
  }

  /* ---- 1.1.1 gallery thumbnails --------------------------------------
   * wcc.js sets mainImg.alt = t.dataset.alt || "", so a thumbnail without
   * data-alt silently turns the main product image decorative.
   */
  var mainImg = document.getElementById('GalleryMainImg');
  if (mainImg) {
    var fallback = mainImg.getAttribute('alt') || document.title;
    new MutationObserver(function () {
      if (!mainImg.getAttribute('alt')) mainImg.setAttribute('alt', fallback);
    }).observe(mainImg, { attributes: true, attributeFilter: ['alt'] });
  }

  /* ---- 1.3.1 Info and Relationships: spec tables ----------------------
   * This block used to target '.spec-table'. Checked against the live
   * preview on 2026-09-08: that class exists on no product page. The PDP
   * renders product.description through Page Crafter markup, where the table
   * carries no class at all and is only reachable as
   * .page-crafter-simple-table-container > table. Every one of those tables
   * is two columns of label and value built entirely from <td>, so a screen
   * reader read out a value like '10985 / 11361' with nothing to say it was
   * the 60F BTU row.
   *
   * The first cell of each row becomes a real <th scope="row"> rather than a
   * <td role="rowheader">, because 'scope' is only valid on <th> and the
   * native element carries the relationship without ARIA. The section's own
   * stylesheet already gives th and td identical borders and padding and the
   * label text is already inside <strong>, so the semantics change and the
   * rendering does not.
   *
   * The old block also wrapped the table in a focusable scroll region. That
   * is dropped on purpose: no table in the catalogue is wider than two
   * columns and none overflows at any viewport, so the region was furniture
   * a keyboard user had to tab through for nothing.
   */
  var usedNames = {};
  document.querySelectorAll('.pdp-desc-body .page-crafter-simple-table-container table').forEach(function (t) {
    if (t.dataset.wccRowhdr) return;
    t.dataset.wccRowhdr = '1';

    if (!t.getAttribute('aria-label')) {
      var name = '';
      var scan = (t.closest('.page-crafter-simple-table-container') || t).previousElementSibling;
      for (var guard = 0; scan && !name && guard < 12; guard++) {
        var h = /^H[1-6]$/.test(scan.tagName) ? scan : scan.querySelector('h1,h2,h3,h4,h5,h6');
        if (h && h.textContent.trim()) name = h.textContent.trim().replace(/\s+/g, ' ');
        scan = scan.previousElementSibling;
      }
      if (!name) name = 'Specifications';
      usedNames[name] = (usedNames[name] || 0) + 1;
      if (usedNames[name] > 1) name += ' (' + usedNames[name] + ')';
      t.setAttribute('aria-label', name);
    }

    [].forEach.call(t.rows, function (row) {
      if (row.cells.length !== 2) return;
      var c = row.cells[0];
      if (c.tagName === 'TH') return;
      var th = document.createElement('th');
      for (var a = 0; a < c.attributes.length; a++) th.setAttribute(c.attributes[a].name, c.attributes[a].value);
      th.setAttribute('scope', 'row');
      while (c.firstChild) th.appendChild(c.firstChild);
      c.parentNode.replaceChild(th, c);
    });
  });
})();
